const GLASS_CONFIGURATOR_PRODUCT = 'glass-configurator-product';

export { GLASS_CONFIGURATOR_PRODUCT };
